export default __webpack_public_path__ + "static/media/HelveticaNeueBold.5ce1b8f9.woff2";